import ResourceManager from "../../components/ResourceManager"
import { useCalendarEventMutations } from "../hooks/use-calendar-event-mutations"
import { useI18n } from "../../hooks/use-i18n"
import { StringMap } from "../../types/common"
import { CalendarEventViewModel } from "../api/calendar-event"
import { useOptions } from "../../options/hooks/use-options"

const EventSuppliersWidget = ({ calendarEvent }: { calendarEvent: CalendarEventViewModel }) => {
  const { updateSuppliers } = useCalendarEventMutations()
  const translations = useTranslations(defaultTranslations)
  const { supplierOptions } = useOptions(calendarEvent.organisation?.id || "")

  const onAddSuppliers = (supplierIds: string[]) => {
    const suppliers = [
      ...calendarEvent.suppliers,
      ...supplierOptions.filter((s) => supplierIds.includes(s.id)).map((s) => ({ id: s.id, name: s.name })),
    ]

    updateSuppliers(calendarEvent.id, suppliers)
  }

  const onRemoveSupplier = (supplierId: string) => {
    const suppliers = calendarEvent.suppliers.filter((s) => s.id !== supplierId)
    updateSuppliers(calendarEvent.id, suppliers)
  }

  const sortedSupplierOptions = supplierOptions
    .slice()
    .sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()))
  const sortedSuppliers = calendarEvent.suppliers
    .slice()
    .sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()))

  return (
    <ResourceManager
      title={translations.title}
      resourceOptions={sortedSupplierOptions}
      resources={sortedSuppliers}
      canAddResource={calendarEvent.canUpdate}
      canRemoveResource={calendarEvent.canUpdate}
      onAddResources={onAddSuppliers}
      onRemoveResource={onRemoveSupplier}
      emptyOptionsMessage={translations.emptyOptionsMessage}
      emptyResourcesMessage={translations.emptyResourcesMessage}
      isMultipleSelection
    />
  )
}

const useTranslations = (defaults = defaultTranslations): EventParticipantsWidgetTranslations => {
  const { translations: t } = useI18n("calendarEvent")
  const translations = (t?.suppliersWidget || {}) as StringMap

  const {
    title = defaults.title,
    emptyOptionsMessage = defaults.emptyOptionsMessage,
    emptyResourcesMessage = defaults.emptyResourcesMessage,
    updateErrorMessage = defaults.updateErrorMessage,
  } = translations

  return {
    title,
    emptyOptionsMessage,
    emptyResourcesMessage,
    updateErrorMessage,
  }
}

const defaultTranslations = {
  title: "Suppliers",
  emptyOptionsMessage: "No suppliers in this organisation",
  emptyResourcesMessage: "This event is not connected to any supplier",
  updateErrorMessage: "Failed to update suppliers",
}

type EventParticipantsWidgetTranslations = typeof defaultTranslations
export default EventSuppliersWidget
